import { matchPath } from "react-router-dom-v5-compat";
import { PATH_HOME, PATH_TRIPS } from "@hopper-b2b/utilities";

import { CHAT_FAB_HIDE_PATHS } from "@/utilities/constants";

const SHOW_PATHS = [PATH_HOME, PATH_TRIPS];

/**
 * Whether the support chat FAB belongs on this route.
 *
 * Also gates the HTS Assist mount, so the widget is only mounted where the FAB
 * that opens it is offered (ASSIST-821).
 */
export const shouldShowChatFab = (pathname: string): boolean => {
  const hideMatch = CHAT_FAB_HIDE_PATHS.some((path) =>
    matchPath({ path, end: false }, pathname)
  );
  const showMatch = SHOW_PATHS.some((path) =>
    matchPath({ path, end: false }, pathname)
  );
  return Boolean(!hideMatch && showMatch);
};
